const APP_ENV = process.env.REACT_APP_APP_ENV || 'dev'

// Suppress console.log on production (previous behavior).
if (APP_ENV === 'production') {
    console.log = () => {}
}

// All values come from REACT_APP_* env vars — no hardcoded fallbacks.
// NOTE: REACT_APP_* vars are inlined at BUILD time in Create React App, so
// they must be set before `npm run build`.
const config = {
    apiUrl: process.env.REACT_APP_API_URL,
    apiHostUrl: process.env.REACT_APP_API_HOST_URL,
    USER_WEB_URL: process.env.REACT_APP_USER_WEB_URL,
    mediaUrl: process.env.REACT_APP_MEDIA_URL,
    s3Endpoint: process.env.REACT_APP_S3_ENDPOINT,
    googleAPI_KEY: process.env.REACT_APP_GOOGLE_API_KEY,
    GOOGLE_CLIENTID: process.env.REACT_APP_GOOGLE_CLIENTID,
}

export const AppConfig = config
